import { useState } from "react";
import { ChevronDown } from "lucide-react";
import siteData from "./data.json";
import SectionHead from "./SectionHead";

const defaultFaq = siteData.Faq;

// ─── Single accordion item ────────────────────────────────────────────────────
function FaqItem({ item, index, isOpen, onToggle }) {
    return (
        <div
            onClick={onToggle}
            className={`
        rounded-[18px] border cursor-pointer overflow-hidden
        transition-all duration-200
        ${isOpen
                    ? "border-violet-300 bg-violet-50 shadow-[0_8px_32px_#7c3aed14]"
                    : "border-gray-200 bg-white shadow-[0_2px_8px_#0000000a] hover:border-violet-200"
                }
      `}
        >
            {/* Question row */}
            <div className="flex items-center gap-4 px-6 py-5 select-none">

                {/* Number badge */}
                <span
                    className={`
            min-w-[32px] h-8 rounded-[10px] text-[15px] font-extrabold flex items-center justify-center tracking-[0.04em] flex-shrink-0
            transition-all duration-200
            ${isOpen
                            ? " text-violet-600"
                            : " text-gray-400"
                        }
          `}
                >
                    {String(index + 1).padStart(2, "0")}
                </span>

                <span
                    className={`
            flex-1 text-[15px] font-bold tracking-[-0.3px] transition-colors duration-200
            ${isOpen ? "text-[#1a1033]" : "text-gray-700"}
          `}
                >
                    {item.q}
                </span>

                <ChevronDown
                    size={18}
                    className={`
            flex-shrink-0 transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)]
            ${isOpen ? "text-violet-600 rotate-180" : "text-gray-400 rotate-0"}
          `}
                />
            </div>

            {/* Answer — animated height */}
            <div
                className="overflow-hidden transition-all duration-[350ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
                style={{ maxHeight: isOpen ? 300 : 0 }}
            >
                <div className="px-6 pb-[22px] pl-[72px] text-sm text-gray-500 leading-[1.75]">
                    {item.a}
                </div>
            </div>
        </div>
    );
}

// ─── Main FAQ Section ─────────────────────────────────────────────────────────
export default function Faq({ faq = defaultFaq, scrollToForm }) {
    const [openIndex, setOpenIndex] = useState(null);
    const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

    const half = Math.ceil(faq.items.length / 2);
    const left = faq.items.slice(0, half);
    const right = faq.items.slice(half);

    return (
        <section className="relative py-24 px-4  md:px-6 overflow-hidden">


            <div className="max-w-[1000px] mx-auto">

                {/* ── Header ── */}
                <SectionHead eyebrow={faq.eyebrow} title={faq.title} subtitle={faq.subtitle} />

                {/* ── Two-column accordion ── */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start">

                    {/* Left column */}
                    <div className="flex flex-col gap-3">
                        {left.map((item, i) => (
                            <FaqItem
                                key={i}
                                item={item}
                                index={i}
                                isOpen={openIndex === i}
                                onToggle={() => toggle(i)}
                            />
                        ))}
                    </div>

                    {/* Right column */}
                    <div className="flex flex-col gap-3">
                        {right.map((item, i) => {
                            const globalIdx = i + half;
                            return (
                                <FaqItem
                                    key={globalIdx}
                                    item={item}
                                    index={globalIdx}
                                    isOpen={openIndex === globalIdx}
                                    onToggle={() => toggle(globalIdx)}
                                />
                            );
                        })}
                    </div>
                </div>

                {/* ── Bottom CTA ── */}
                <div className="mt-[52px] text-center flex flex-col items-center gap-4">
                    <p className="text-sm text-gray-400">
                        Savolingizga javob topa olmadingizmi? Telegram orqali <a href="https://t.me/DevCoreHR" className="text-violet-600 hover:underline">t.me/DevCoreHR</a> ga murojaat qiling
                    </p>

                </div>

            </div>
        </section>
    );
}